<template>
  <aside class="menu">
    <p class="menu-label">
      Projects
    </p>

    <ul class="menu-list">
      <li v-for="(project, index) of projects" :key="index">
        <router-link
         :class="{'is-active': selected(project, index)}"
         :to="{name: 'hotpaths', query: {id: project.id}}"
        >
          {{ project.name }}
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: "LeftMenu",
  props: {
    projects: Array,
    selectedProject: Number
  },
  methods: {
    selected(project, idx) {
      if (this.selectedProject === 0 && idx === 0) {
        return true;
      }

      return project.id === this.selectedProject;
    }
  }
};
</script>
